import { render, staticRenderFns } from "./LegalTextEvent.vue?vue&type=template&id=390cf676"
import script from "./LegalTextEvent.vue?vue&type=script&lang=js"
export * from "./LegalTextEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports